import { Button, Divider, Group, Loader, Stack } from "@mantine/core";
import PostalMime from "postal-mime";
import { useState } from "react";
import { downloadEML } from "../../../../../../../../api/PRMAPI";
import { getAttachmentIcon } from "../../../../../../files/fileUtils";
import AttachmentPreview from "./AttachmentPreview";

async function downloadAttachmentFromEml(eml, filename) {
  // Convert text to ArrayBuffer
  const encoder = new TextEncoder();
  const arrayBuffer = encoder.encode(eml).buffer;

  const parser = new PostalMime();
  const email = await parser.parse(arrayBuffer);

  // Helper to normalize spaces and trim (e.g., "word1   word2 " -> "word1 word2")
  const normalizeString = (str) => (str ? str.replace(/\s+/g, " ").trim() : "");
  const normalizedTarget = normalizeString(filename);

  // Find the attachment by comparing normalized filenames
  const attachment = email.attachments.find(
    (a) => normalizeString(a.filename) === normalizedTarget
  );

  if (!attachment) {
    console.error("Attachment not found:", filename);
    return;
  }

  const blob = new Blob([attachment.content], { type: attachment.mimeType });
  const url = URL.createObjectURL(blob);

  const a = document.createElement("a");
  a.href = url;
  // Use the original parsed filename for the download
  a.download = attachment.filename;
  a.click();

  URL.revokeObjectURL(url);
}

const MessageAttachments = ({ item, isLinkedin, isMobile }) => {
  const [loading, setLoading] = useState(false);
  const handleDownload = (attachment) => {
    setLoading(true);

    if (attachment?.download_url || attachment?.file_url) {
      window.open(attachment?.download_url || attachment?.file_url, "_blank");
      setLoading(false);
    }
    else {
      downloadEML({
        reply_id: item.id,
        id: item?.history_type === "sent" ? item?.id : undefined,
        isBlob: false,
      })
        .then((r) => {
          downloadAttachmentFromEml(r.data, attachment?.name || attachment);
        })
        .finally(() => setLoading(false));
    }
  };

  const getAttachmentName = (attachment) => {
    if (attachment?.name) return attachment.name;
    if (attachment?.type === "vectorImage") return `Image`;
    if (attachment?.type === "externalMedia") return "Media";
    return attachment?.type || "Attachment";
  }

  if (item?.attachments?.length > 0) {
    return (
      <>
        {
          !isLinkedin &&
          <Divider my={4} />
        }
        <Group py={isLinkedin ? 0 : 8} mt={isLinkedin ? 4 : 0} px={isMobile ? 8 : 0} >
          {item?.attachments.map((attachment) => (
            <Stack
              key={attachment?.download_url || attachment?.name} gap={4}>
              <Button
                variant="light"
                leftSection={
                  loading ? <Loader size={16} /> : getAttachmentIcon(attachment, { size: 16 })
                }
                pl={8}
                tt={"none"}
                radius={"sm"}
                fz={isMobile ? 12 : 14}
                fw={500}
                disabled={loading}
                onClick={() => handleDownload(attachment)}
                size={isMobile ? "xs" : "sm"}
                w={isMobile ? "100%" : undefined}
                maw={isMobile ? "100%" : 340}
              >
                {getAttachmentName(attachment)}
              </Button>

              <AttachmentPreview attachment={attachment} />
            </Stack>
          ))}
        </Group>
      </>
    );
  }
  return;
};

export default MessageAttachments;
